<h1 mat-dialog-title>{{ 'platformNotes.dialog.view.title' | translate }}</h1>
<mat-dialog-content>
  <app-card-spinner [visible]="dialogIsLoading" type="zero"></app-card-spinner>
  <div class="row mt-3 mb-3">
    <div class="col-12 createdBy">{{ createdBy }}</div>
    <div class="col-12 createdAt">{{ createdAt }} - {{ category }}</div>
    <div class="col-12 title">{{ title }}</div>
    <div class="col-12 description">{{ description }}</div>
    <div class="col-12 file" *ngIf="file && file.path">
      <a href="{{ configService.apiHost }}/{{ file.path }}" target="_blank" 
        matTooltip="{{ 'common.words.clickToOpen' | translate }}">
        {{ file.originalName }}
      </a>
    </div>
  </div>
</mat-dialog-content> <!-- mat-dialog-content -->

<div mat-dialog-actions>
  <a mat-button (click)="onClose()" mat-raised-button mat-default
  class="ml-3">{{ 'common.cta.close' | translate }}</a>
</div>
